import { connect } from 'react-redux';
import { splitTreatmentsFetchRequest } from 'common/actions';

import { toggleCartVisibility, sidebarFocusChanged } from '../actions';
import { getTotalSavings, getLineItemsAtCartOpen } from '../selectors';
import Sidebar from '../components/Sidebar';

const mapStateToProps = state => {
  return {
    isOpen: state.isOpen,
    currentOrder: state.currentOrder,
    shippingCost: state.shippingCost,
    lineItemsProcessing: state.lineItemsProcessing,
    variants: state.variants,
    totalSavings: getTotalSavings(state),
    lineItemsLength: getLineItemsAtCartOpen(state).length,
  };
};

const mapDispatchToProps = dispatch => ({
  toggleVisibility: () => {
    dispatch(toggleCartVisibility());
  },
  mouseEnteredSidebar: () => {
    dispatch(sidebarFocusChanged(true));
  },
  mouseExitedSidebar: () => {
    dispatch(sidebarFocusChanged(false));
  },
  fetchSplitTreatments: () => {
    dispatch(splitTreatmentsFetchRequest());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidebar);
